/** Bump whenever client and server stop being wire-compatible. */
export const PROTOCOL_VERSION = 32;

export const ROOM_NAME = "arena";
export const MAX_PLAYERS = 8;

/** Server simulation rate. One client input == one fixed step == one tick. */
export const TICK_RATE = 30;
export const TICK_MS = 1000 / TICK_RATE;

export const DEFAULT_SERVER_PORT = 2567;

/**
 * Path prefix under which the game server is reachable from the browser.
 * In development Vite proxies it to the server; in production the reverse
 * proxy (Caddy) does the same, so the client always connects same-origin.
 */
export const SERVER_PATH = "/colyseus";
